module.exports = __webpack_public_path__ + "static/img/logo.910f5c6.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/h5/logo.png
// module id = w1l2
// module chunks = 1